// sizing and positioning tag filter so we can have a cool x-scroll on it for mobile

import { Utility, getTargetContainersExceptPageOverlay } from '../utility/utility_controller'

var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		var $target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)

		var $grids = $target.find('.type-productsgrid')
		if ($grids.length > 0) {
			sizeFilters()
		}
	})

	window.laytheme.on('overlayshown', function ($target) {
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		var $grids = $target.find('.type-productsgrid')
		if ($grids.length > 0) {
			sizeFilters()
		}
	})
}

var sizeFilters = function () {
	switch (Utility.screenSize) {
		case 'desktop':
		case 'tablet':
			jQuery('.one-col-row .type-productsgrid').each(function () {
				var $tagFilter = jQuery(this).find('.lay-productsgrid-tagfilter')
				if ($tagFilter.length > 0 && $tagFilter.hasClass('mobile-one-line')) {
					$tagFilter.css({
						width: '',
						paddingLeft: '',
						paddingRight: '',
						transform: '',
					})
				}

				var $catFilter = jQuery(this).find('.lay-productsgrid-filter')
				if ($catFilter.length > 0 && $catFilter.hasClass('mobile-one-line')) {
					$catFilter.css({
						width: '',
						paddingLeft: '',
						paddingRight: '',
						transform: '',
					})
				}
			})
			break
		case 'phone':
			// only size this if productsgrid is only element in row, hm not sure, just want to make sure it is a productsgrid that is 100% width on mobile
			jQuery('.one-col-row .type-productsgrid').each(function () {
				var $tagFilter = jQuery(this).find('.lay-productsgrid-tagfilter')

				if ($tagFilter.length > 0 && $tagFilter.hasClass('mobile-one-line')) {
					var $row = jQuery(this).closest('.row')
					var style2 = $row[0].currentStyle || window.getComputedStyle($row[0])

					$tagFilter.css({
						width: window.innerWidth + 'px',
						paddingLeft: style2.paddingLeft,
						paddingRight: style2.paddingRight,
					})

					$tagFilter.css({
						transform: 'translateX( ' + style2.paddingLeft + ' )',
					})
				}

				var $catFilter = jQuery(this).find('.lay-productsgrid-filter')
				if ($catFilter.length > 0 && $catFilter.hasClass('mobile-one-line')) {
					var $row = jQuery(this).closest('.row')
					var style2 = $row[0].currentStyle || window.getComputedStyle($row[0])

					$catFilter.css({
						width: window.innerWidth + 'px',
						paddingLeft: style2.paddingLeft,
						paddingRight: style2.paddingRight,
					})

					$catFilter.css({
						transform: 'translateX( -' + style2.paddingLeft + ' )',
					})
				}
			})
			break
	}
}

var i = function () {
	bindOnContentReady()
	jQuery(window).on('window_width_changed', function () {
		sizeFilters()
	})
}

var productsgrid_tagfilter_sizing_controller = {
	i: i,
}

export default productsgrid_tagfilter_sizing_controller
